import React from "react";
import {Line} from "react-chartjs-2";
import {TREASURY_HIGH_CHART_COLOR, TREASURY_LOW_CHART_COLOR} from '../../../../scripts/constants';
import ChartDataLabels from 'chartjs-plugin-datalabels';

class BankRateLineChart extends React.Component {

    constructor(props) {
        super(props);
        this.chartReference = React.createRef();
        this.state = {
          initialLoad: true,
          chartDataSet1: [],
          chartDataSet2: []
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.dataReady && this.state.initialLoad) {
        this.setState({
          initialLoad: false,
          chartDataSet1: this.props.data.chartDataSet1,
          chartDataSet2: this.props.data.chartDataSet2
        });
      }
    }

  chartOptions = {
      maintainAspectRatio:false,
      legend: {
        position: 'bottom'
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      title: {
        display: true,
        fontSize: 16,
        text: this.props.title
      },
      plugins: {
        datalabels: {
          display: false
        }
      },
      tooltips: {
        display: false
      },
      scales: {
        yAxes: [{
          position: 'right',
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            beginAtZero: true,
            callback: function(value) {
              return value.toFixed(2) + '%';
            }
          }
        }],
        xAxes: [{
          position: 'top',
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false
          },
          ticks: {
            display: true,
            maxRotation: 0,
            maxTicksLimit: 5,
            padding: 10,
            callback: (value) => {
              return (value === this.state.chartDataSet1[0].label) ? '' : value;
            }
          }
        }]
      }
    };



    render() {
      let chartData = {
        labels: this.state.chartDataSet1.map(item => item.label),
        datasets: [
          {
            label: 'Low',
            data: this.state.chartDataSet2.map(item => item.data),
            pointRadius: 0,
            pointHitRadius: 0,
            backgroundColor: TREASURY_LOW_CHART_COLOR
          },
          {
            label: 'High',
            data: this.state.chartDataSet1.map(item => item.data),
            pointRadius: 0,
            pointHitRadius: 0,
            backgroundColor: TREASURY_HIGH_CHART_COLOR
          }
        ]
      };
      return (
        <Line ref={this.chartReference}
              plugins={[ChartDataLabels]}
             data={ chartData }
             options={this.chartOptions}
        />
      );
    }
}

export default BankRateLineChart;